//#region src/detectBrowser.ts
function e() {
	if (typeof navigator > "u") return "unknown";
	let e = (navigator.userAgent ?? "").toLowerCase();
	return e ? e.includes("edg/") ? "edge" : e.includes("firefox") || e.includes("fxios") ? "firefox" : e.includes("chrome") || e.includes("chromium") || e.includes("crios") ? "chrome" : e.includes("safari") ? "safari" : "unknown" : "unknown";
}
//#endregion
export { e as detectBrowser };
